/**
 * AskmyPets Buggy-Finder Quiz
 * Theme-natives Drawer, Scoring nach Phase-2-Spec, Redirect zu Storefront-Filter-URL.
 * Persistenz via localStorage (14 Tage TTL, funktional kein Tracking).
 */
(function () {
  'use strict';

  var dataScript = document.getElementById('amp-quiz-data');
  if (!dataScript) return;

  var allBuggys = [];
  try {
    allBuggys = JSON.parse(dataScript.textContent.trim());
  } catch (e) {
    console.error('AMP Quiz: parse error', e);
    return;
  }

  var drawer = document.getElementById('amp-quiz-drawer');
  if (!drawer) return;

  // === Drawer aus Stacking-Context-Käfig (.section__wrapper.isolate) befreien ===
  // Sonst wird der Drawer-Header vom Site-Header überlagert (z-index 0 vom .isolate-Wrapper).
  if (drawer.parentElement !== document.body) {
    document.body.appendChild(drawer);
  }

  // === Configuration ===
  var COLLECTION_URL = '/collections/hundebuggys-fahrradanhanger';
  var STORAGE_KEY = 'amp_buggy_quiz_v1';
  var STORAGE_TTL_MS = 14 * 24 * 60 * 60 * 1000; // 14 days
  var BUCKET_TO_NUM = { 'bis-12': 12, '13-20': 20, '21-25': 25, '26-30': 30, '31-50': 50 };
  var USE_CASE_LABELS = {
    city: 'für Stadt & Alltag',
    terrain: 'für Wald & Wiesen',
    senior: 'für Senior- und Reha-Hunde'
  };

  // === Quiz-Slug → Filter-Label Mapping (für GID-Lookup in collection.filters) ===
  // Shopify Search & Discovery erwartet GIDs als URL-Werte, nicht unsere Slugs.
  // Slug → Filter-Label → GID-Wert (gid://shopify/FilterSettingGroup/...).
  var QUIZ_SLUG_TO_LABEL = {
    fits_dog_weight: {
      'bis-12': 'Bis 12 kg',
      '13-20': '13 – 20 kg',
      '21-25': '21 – 25 kg',
      '26-30': '26 – 30 kg',
      '31-50': '31 – 50 kg'
    },
    convertible: {
      'none': 'Nur Buggy',
      'bike': 'Auch Fahrradanhänger',
      'bike_optional': 'Optional Fahrradanhänger',
      'car': 'Auch Autositz / Transportbox'
    },
    use_cases: {
      'city': 'Stadt & Alltag',
      'terrain': 'Wald & Wiesen',
      'senior': 'Senior / Reha'
    }
  };

  // GID-Map kommt aus Snippet via JSON-Script. Fallback auf leeres Map.
  var GID_MAP = {};
  try {
    var gidScript = document.getElementById('amp-quiz-gid-map');
    if (gidScript) GID_MAP = JSON.parse(gidScript.textContent.trim());
  } catch (e) { console.warn('AMP Quiz: GID-Map parse error', e); }

  function slugToGid(metafield, slug) {
    var label = (QUIZ_SLUG_TO_LABEL[metafield] || {})[slug];
    if (!label) return null;
    var map = GID_MAP[metafield] || {};
    return map[label] || null;
  }

  // === Quiz State ===
  var state = {
    weight: null,
    use_cases: [],
    convertible: null,
    step: 1
  };

  // === Analytics Tracking (Consentmo-gated via Shopify Customer Privacy API) ===
  function ampCanTrack() {
    try {
      if (window.Shopify && window.Shopify.customerPrivacy &&
          typeof window.Shopify.customerPrivacy.userCanBeTracked === 'function') {
        return window.Shopify.customerPrivacy.userCanBeTracked() === true;
      }
    } catch (e) {}
    // Fallback: wenn Consentmo direkt expose
    if (window.ConsentmoConsent) {
      return window.ConsentmoConsent.analytics === true || window.ConsentmoConsent.statistics === true;
    }
    // Safe default: kein Consent bekannt -> kein Tracking
    return false;
  }

  function ampTrack(eventName, params) {
    if (!ampCanTrack()) return;
    var payload = Object.assign({}, params || {}, {
      event: eventName,
      event_category: 'amp_buggy_quiz'
    });
    // GA4 via dataLayer (Shopify-Pixel / GTM)
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    // GA4 direkt via gtag, falls vorhanden
    if (typeof window.gtag === 'function') {
      try { window.gtag('event', eventName, payload); } catch (e) {}
    }
  }

  // === Scoring (an Storefront-Filter angeglichen, Quiz-Treffer = Filter-Treffer) ===
  function scoreBuggy(b) {
    var score = 0;
    var maxScore = 0;
    var unsureMode = state.weight === 'unsicher';

    // Hard rule 1: weight-bucket muss in fits_dog_weight-Liste sein
    // (Spiegelt Storefront-Filter: filter.p.m.custom.fits_dog_weight=<bucket>)
    if (!unsureMode && state.weight) {
      if (!b.fits_dog_weight || b.fits_dog_weight.indexOf(state.weight) < 0) return null;
      maxScore += 30;
      // Score-Bonus über max_weight (numerische Nähe) für Sortier-Differenzierung
      if (b.max_weight) {
        var dogWeight = BUCKET_TO_NUM[state.weight];
        if (b.max_weight < dogWeight + 3) score += 20;       // tight fit
        else if (b.max_weight <= dogWeight + 15) score += 30; // good reserve
        else score += 24;                                       // a lot of reserve
      } else {
        score += 25; // default wenn max_weight nicht gesetzt
      }
    }

    // Hard rule 2: convertible-Match (alle drei Werte sind Hard-Filter)
    // (Spiegelt Storefront-Filter: filter.p.m.custom.convertible=<value>)
    if (state.convertible) {
      if (state.convertible === 'bike') {
        // Filter-URL enthält BEIDE: bike + bike_optional → beide passen
        maxScore += 25;
        if (b.convertible === 'bike') score += 25;
        else if (b.convertible === 'bike_optional') score += 18;
        else return null;
      } else if (state.convertible === 'car') {
        maxScore += 25;
        if (b.convertible === 'car') score += 25;
        else return null;
      } else if (state.convertible === 'none') {
        maxScore += 10;
        if (b.convertible === 'none') score += 10;
        else return null; // Hard-Filter konsistent mit Storefront
      }
    }

    // Hard rule 3: use_cases — mindestens 1 Match
    // (Spiegelt Storefront-Filter: filter.p.m.custom.use_cases=<value>, multi-value = OR)
    if (state.use_cases.length > 0) {
      var hasUcMatch = false;
      for (var i = 0; i < state.use_cases.length; i++) {
        if (b.use_cases && b.use_cases.indexOf(state.use_cases[i]) >= 0) {
          hasUcMatch = true;
          break;
        }
      }
      if (!hasUcMatch) return null;

      maxScore += state.use_cases.length * 20;
      state.use_cases.forEach(function (uc) {
        if (b.use_cases && b.use_cases.indexOf(uc) >= 0) {
          score += 20;
          if (uc === 'terrain') {
            maxScore += 15;
            if ((b.gelaendetauglichkeit || 0) >= 7) score += 8;
            if ((b.daempfung_komfort || 0) >= 7) score += 7;
          } else if (uc === 'senior') {
            maxScore += 12;
            if ((b.daempfung_komfort || 0) >= 7) score += 8;
            if (b.closure_type === 'nozip') score += 4;
          } else if (uc === 'city') {
            maxScore += 6;
            if ((b.kompaktheit || 0) >= 7) score += 6;
          }
        }
      });
    }

    return { score: score, maxScore: maxScore || 1, buggy: b };
  }

  function calculateResults() {
    var scored = allBuggys.map(scoreBuggy).filter(function (r) { return r !== null; });
    scored.sort(function (a, b) {
      var ra = a.score / a.maxScore;
      var rb = b.score / b.maxScore;
      return rb - ra;
    });
    return scored;
  }

  // === Step Rendering ===
  function showStep(n) {
    state.step = n;
    drawer.querySelectorAll('.amp-quiz-step').forEach(function (el) {
      el.hidden = el.getAttribute('data-amp-step') !== String(n);
    });
    var cur = drawer.querySelector('[data-amp-step-current]');
    var tot = drawer.querySelector('[data-amp-step-total]');
    if (cur) cur.textContent = (n === 'result') ? '✓' : n;
    if (tot) tot.textContent = '3';
    var back = drawer.querySelector('[data-amp-back]');
    if (back) back.hidden = (n === 1);
    // Scroll content to top
    var content = drawer.querySelector('.drawer-content');
    if (content) content.scrollTop = 0;
  }

  function renderResult() {
    var results = calculateResults();
    var resultEl = drawer.querySelector('[data-amp-step="result"]');

    if (results.length === 0) {
      resultEl.querySelector('[data-amp-result-tag]').textContent = 'Keine Empfehlung';
      resultEl.querySelector('[data-amp-result-title]').textContent = 'Aktuell kein passender Buggy';
      resultEl.querySelector('[data-amp-result-because]').textContent =
        'Für deine Angaben haben wir aktuell kein passendes Modell im Sortiment. Schau dir trotzdem alle Buggys an — vielleicht ist ein anderer passend, der nicht alle deine Kriterien erfüllt.';
      resultEl.querySelector('[data-amp-result-card]').innerHTML = '';
      resultEl.querySelector('[data-amp-result-alts]').innerHTML = '';
      resultEl.querySelector('[data-amp-result-alts-heading]').hidden = true;
      var ctaEmpty = resultEl.querySelector('[data-amp-result-cta]');
      ctaEmpty.href = COLLECTION_URL + '?from_quiz=1';
      ctaEmpty.innerHTML = '<span>Alle <span data-amp-result-count>' + allBuggys.length + '</span> Buggys ansehen</span>';
      ampTrack('amp_quiz_result_shown', {
        top_match_handle: '',
        top_match_score: 0,
        results_count: 0,
        weight_bucket: state.weight || '',
        use_cases: state.use_cases.join(','),
        convertible_choice: state.convertible || ''
      });
      saveState();
      return;
    }

    var top = results[0];
    var rawPct = Math.round((top.score / top.maxScore) * 100);
    var unsureMode = state.weight === 'unsicher';
    var displayPct = unsureMode ? Math.min(85, rawPct) : Math.min(94, rawPct);

    // Tag with match percent
    var tagText = unsureMode
      ? ('Empfehlung · ' + displayPct + '% Übereinstimmung')
      : ('Dein Top-Match · ' + displayPct + '% Übereinstimmung');
    resultEl.querySelector('[data-amp-result-tag]').textContent = tagText;

    // Title
    resultEl.querySelector('[data-amp-result-title]').textContent = top.buggy.title;

    // Begründung
    var because = buildBecause(top, state, unsureMode);
    resultEl.querySelector('[data-amp-result-because]').textContent = because;

    // Top-Card
    var cardEl = resultEl.querySelector('[data-amp-result-card]');
    cardEl.innerHTML = '';
    if (top.buggy.image) {
      var img = document.createElement('img');
      img.src = top.buggy.image;
      img.alt = top.buggy.title;
      cardEl.appendChild(img);
    }
    var info = document.createElement('div');
    info.className = 'amp-result-card-info';
    var html = '<h4 class="amp-result-card-name">' + escapeHTML(top.buggy.title) + '</h4>';
    html += '<p class="amp-result-card-price">' + formatPrice(top.buggy.price) + ' €</p>';
    if (top.buggy.lieferzeit) {
      html += '<p class="amp-result-card-meta">' + escapeHTML(top.buggy.lieferzeit) + '</p>';
    }
    info.innerHTML = html;
    cardEl.appendChild(info);
    var topLink = document.createElement('a');
    topLink.href = top.buggy.url;
    topLink.className = 'button button--primary button--small button--hover-animate amp-result-card-cta';
    topLink.textContent = 'Ansehen';
    cardEl.appendChild(topLink);

    // Alternativen (2 weitere falls vorhanden)
    var altsEl = resultEl.querySelector('[data-amp-result-alts]');
    var altsHeading = resultEl.querySelector('[data-amp-result-alts-heading]');
    altsEl.innerHTML = '';
    var alts = results.slice(1, 3);
    if (alts.length > 0) {
      altsHeading.hidden = false;
      alts.forEach(function (r) {
        var altPct = Math.min(unsureMode ? 80 : 92, Math.round((r.score / r.maxScore) * 100));
        var altLink = document.createElement('a');
        altLink.href = r.buggy.url;
        altLink.className = 'amp-result-alternative';
        altLink.innerHTML =
          (r.buggy.image ? '<img src="' + r.buggy.image + '" alt="' + escapeHTML(r.buggy.title) + '">' : '') +
          '<div class="amp-result-card-info">' +
          '<div class="amp-result-card-match">' + altPct + ' % Match</div>' +
          '<div class="amp-result-card-name">' + escapeHTML(r.buggy.title) + '</div>' +
          '<div class="amp-result-alternative-price">' + formatPrice(r.buggy.price) + ' €</div>' +
          '</div>';
        altsEl.appendChild(altLink);
      });
    } else {
      altsHeading.hidden = true;
    }

    // CTA: Bei 1 Treffer → direkt zur Produkt-Seite; sonst Filter-URL
    var ctaResult = resultEl.querySelector('[data-amp-result-cta]');
    if (results.length === 1) {
      ctaResult.href = top.buggy.url;
      ctaResult.innerHTML = '<span>Diesen passenden Buggy ansehen</span>';
    } else {
      ctaResult.href = buildFilterURL(state);
      ctaResult.innerHTML = '<span>Alle <span data-amp-result-count>' + results.length + '</span> passenden Buggys ansehen</span>';
    }

    ampTrack('amp_quiz_result_shown', {
      top_match_handle: top.buggy.handle,
      top_match_score: displayPct,
      results_count: results.length,
      weight_bucket: state.weight || '',
      use_cases: state.use_cases.join(','),
      convertible_choice: state.convertible || ''
    });

    saveState();
  }

  function buildBecause(top, state, unsureMode) {
    var parts = [];
    if (!unsureMode && state.weight) {
      parts.push('passt für deinen Hund (bis ' + top.buggy.max_weight + ' kg)');
    } else if (unsureMode) {
      parts.push('großer Einsatzbereich (bis ' + top.buggy.max_weight + ' kg)');
    }
    if (state.convertible === 'bike') {
      if (top.buggy.convertible === 'bike') parts.push('auch als Fahrradanhänger nutzbar');
      else if (top.buggy.convertible === 'bike_optional') parts.push('optional als Fahrradanhänger erweiterbar');
    } else if (state.convertible === 'car') {
      parts.push('auch als Autositz oder Transportbox');
    }
    state.use_cases.forEach(function (uc) {
      if (top.buggy.use_cases && top.buggy.use_cases.indexOf(uc) >= 0) {
        if (USE_CASE_LABELS[uc]) parts.push(USE_CASE_LABELS[uc]);
      }
    });
    if (parts.length === 0) {
      return 'Empfohlen basierend auf deinen Angaben.';
    }
    return 'Empfohlen, weil: ' + parts.join(' · ') + '.';
  }

  function buildFilterURL(state) {
    var params = [];
    function add(metafield, slug) {
      var gid = slugToGid(metafield, slug);
      // GID bevorzugt; Fallback Slug (für lokale Tests ohne Live-Mapping)
      var val = gid || slug;
      params.push('filter.p.m.custom.' + metafield + '=' + encodeURIComponent(val));
    }
    if (state.weight && state.weight !== 'unsicher') {
      add('fits_dog_weight', state.weight);
    }
    if (state.convertible) {
      if (state.convertible === 'bike') {
        add('convertible', 'bike');
        add('convertible', 'bike_optional');
      } else if (state.convertible === 'car') {
        add('convertible', 'car');
      } else if (state.convertible === 'none') {
        add('convertible', 'none');
      }
    }
    state.use_cases.forEach(function (uc) {
      add('use_cases', uc);
    });
    // Marker damit Collection-Page nach Lade-Ende automatisch zum Filter scrollt
    params.push('from_quiz=1');
    return COLLECTION_URL + '?' + params.join('&');
  }

  function formatPrice(p) {
    return Number(p).toFixed(2).replace('.', ',');
  }

  function escapeHTML(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // === Persistence ===
  function saveState() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ state: state, ts: Date.now() }));
    } catch (e) {}
  }

  function clearState() {
    try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
  }

  // === Event Wiring ===
  drawer.addEventListener('click', function (e) {
    var opt = e.target.closest('.amp-quiz-option');
    if (opt) {
      handleOptionClick(opt);
      return;
    }

    if (e.target.closest('[data-amp-next]')) {
      if (state.use_cases.length > 0) {
        ampTrack('amp_quiz_step_completed', { quiz_step: 2, use_cases: state.use_cases.join(',') });
        showStep(3);
      }
      return;
    }

    if (e.target.closest('[data-amp-show-result]')) {
      if (state.convertible) {
        ampTrack('amp_quiz_step_completed', { quiz_step: 3, convertible: state.convertible });
        showStep('result');
        renderResult();
      }
      return;
    }

    var ctaCard = e.target.closest('.amp-result-card-cta');
    if (ctaCard) {
      ampTrack('amp_quiz_top_match_clicked', { product_url: ctaCard.getAttribute('href') || '' });
      return;
    }

    var ctaFilter = e.target.closest('[data-amp-result-cta]');
    if (ctaFilter) {
      var countEl = ctaFilter.querySelector('[data-amp-result-count]');
      ampTrack('amp_quiz_result_cta_clicked', {
        results_count: countEl ? parseInt(countEl.textContent, 10) : 0,
        target_url: ctaFilter.getAttribute('href') || ''
      });
      return;
    }

    var altLink = e.target.closest('.amp-result-alternative');
    if (altLink) {
      ampTrack('amp_quiz_alternative_clicked', { product_url: altLink.getAttribute('href') || '' });
      return;
    }

    if (e.target.closest('[data-amp-back]')) {
      if (state.step === 'result') showStep(3);
      else if (state.step > 1) showStep(state.step - 1);
      return;
    }

    if (e.target.closest('[data-amp-restart]')) {
      resetQuiz();
      return;
    }
  });

  function handleOptionClick(opt) {
    var stepEl = opt.closest('.amp-quiz-step');
    var stepNum = stepEl.getAttribute('data-amp-step');
    var value = opt.getAttribute('data-value');
    var parent = opt.closest('.amp-quiz-options');
    var isMulti = parent.hasAttribute('data-amp-multi');

    if (stepNum === '1') {
      parent.querySelectorAll('.amp-quiz-option').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      opt.setAttribute('aria-pressed', 'true');
      state.weight = value;
      ampTrack('amp_quiz_step_completed', { quiz_step: 1, weight: value });
      setTimeout(function () { showStep(2); }, 250);
      return;
    }

    if (stepNum === '2') {
      var idx = state.use_cases.indexOf(value);
      if (idx >= 0) {
        state.use_cases.splice(idx, 1);
        opt.setAttribute('aria-pressed', 'false');
      } else if (state.use_cases.length < 2) {
        state.use_cases.push(value);
        opt.setAttribute('aria-pressed', 'true');
      }
      var next = stepEl.querySelector('[data-amp-next]');
      if (next) next.disabled = state.use_cases.length === 0;
      return;
    }

    if (stepNum === '3') {
      parent.querySelectorAll('.amp-quiz-option').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      opt.setAttribute('aria-pressed', 'true');
      state.convertible = value;
      var showBtn = stepEl.querySelector('[data-amp-show-result]');
      if (showBtn) showBtn.disabled = false;
      ampTrack('amp_quiz_step_completed', { quiz_step: 3, convertible: value });
      setTimeout(function () { showStep('result'); renderResult(); }, 250);
      return;
    }
  }

  function resetQuiz() {
    ampTrack('amp_quiz_restarted', {});
    state.weight = null;
    state.use_cases = [];
    state.convertible = null;
    drawer.querySelectorAll('.amp-quiz-option').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
    drawer.querySelectorAll('[data-amp-next]').forEach(function (b) { b.disabled = true; });
    drawer.querySelectorAll('[data-amp-show-result]').forEach(function (b) { b.disabled = true; });
    clearState();
    showStep(1);
  }

  // === Drawer Open Tracking ===
  document.querySelectorAll('.amp-quiz-open').forEach(function (opener) {
    opener.addEventListener('click', function () {
      ampTrack('amp_quiz_opened', { quiz_version: 'v1' });
    });
  });

  // === Init ===
  showStep(1);
})();
